export default "__VITE_ASSET__DAJ_rcsv__"